module.exports = __webpack_public_path__ + "static/img/ios_pu.934d3fb1.png";